import React from 'react'

export default function EmptyRecentCard() {
  return (
    <div className="traffic-fine-empty-card-wrap">
      <div className="traffic-fine-empty-card">
        <div className="traffic-fine-empty-card-title">
          <div>Tra cứu phạt nguội</div>
          <div>hoàn toàn miễn phí</div>
        </div>

        <div className="traffic-fine-empty-card-mock">
          <div className="traffic-fine-empty-card-mock-left" />
          <div className="traffic-fine-empty-card-mock-right">
            <div className="traffic-fine-empty-card-mock-item" />
            <div className="traffic-fine-empty-card-mock-item" />
          </div>
        </div>
      </div>
    </div>
  )
}
